import { array, object, string } from 'yup'

const orderEventSchema = object().shape({
  startTime: string().default('').nullable(),
  endTime: string().default('').nullable(),
  name: string().default('').nullable(),
  address: string().default('').nullable(),
  loadType: string().default('').nullable(),
  loadCount: string().default('').nullable(),
  temperatureValue: string().default('').nullable(),
  hazmat: string().default('').nullable(),
  pickupNumber: string().default('').nullable(),
  weightValue: string().default('').nullable(),
  notes: string().default('').nullable(),
  _orderEventId: string().default('').nullable(), // Track orderEventId for existing events
  _eventType: string().default('').nullable(), // Track event type for new events
})

export const verifyOrderFormSchema = object().shape({
  customerName: string().default('').nullable(),
  address: string().default('').nullable(),
  loadNumber: string().default('').nullable(),
  billingEmail: string()
    .email('Please enter a valid email address')
    .default('')
    .nullable(),
  notificationEmail: string().email().default('').nullable(),
  accountPayableEmail: string().email().default('').nullable(),
  phone: string().default('').nullable(),
  other: string().default('').nullable(),
  currency: string().default('CAD').nullable(),
  baseRate: string().default('').nullable(),
  detentionCharges: string().default('').nullable(),
  layoverCharges: string().default('').nullable(),
  fuelSurcharge: string().default('').nullable(),
  otherCharges: string().default('').nullable(),
  notes: string().default('').nullable(),
  orderEvents: array().of(orderEventSchema),
})
